<template>
  <v-app>
    <v-content>
      <router-view v-if="!loading" />
    </v-content>
  </v-app>
</template>

<script>
import storage from '../../utility/storage';
  export default {
    name: 'Default',
    data () {
      return {
        loading: true
      }
    },
    computed:{
      theme(){
        return (this.$vuetify.theme.dark) ? 'dark' : 'light'
      }
    },
    mounted () {
      if (storage.getString('is_undermaintenance') == 'true') {
        this.$router.push({name: 'maintenance'})
      }
      this.loading = false
    }
  };
</script>